import { RFIDCardDetails } from './../model/rfid-card.model';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { Identity } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { RFIDCard } from '../model/rfid-card.model';

@Injectable({
    providedIn: 'root'
  })
  export class RFIDCardService {

    constructor(private appServerAPI: AppServerAPI) { }

    getRFIDCards(): Observable<RFIDCard[]> {
      return this.appServerAPI.execute<RFIDCard[]>('/client/admin/rfidcard', {});
    }

    getRFIDCardDetails(identity: Identity): Observable<RFIDCardDetails> {
      return this.appServerAPI.execute<RFIDCardDetails>('/client/admin/rfidcard/details', identity);
    }

    saveRFIDCard(RFIDCard: RFIDCardDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/rfidcard/save', RFIDCard);
    }

    createRFIDCard(RFIDCard: RFIDCardDetails): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/rfidcard/create', RFIDCard);
    }

    deleteRFIDCard(identity: Identity): Observable<ServiceResponse> {
      return this.appServerAPI.execute<ServiceResponse>('/client/admin/rfidcard/delete', identity);
    }
  }
